
if (localStorage.getItem("siteLoaded")) {
    $('.shopify-section-group-prelaunch-group').remove();
    $('html').addClass('enable-scroll');
}
else {

/*
let initialOverlay = $('.initial-landing');
let videoOverlay = $('.video-overlay');
let logoHeight;
*/
//initialOverlay.addClass('showContent');


$('html').addClass('siteEntered');
$('.intro-overlay').addClass('removeBg');
$('.about-popup').addClass('showAboutPopup');


/*
function rotatePrompts() {
    let currentPrompt = $('.showPrompt');
    currentPrompt.removeClass('showPrompt');
    currentPrompt.addClass('moveUp');
    if(currentPrompt.next('span')[0] != undefined) {
        currentPrompt.next().addClass('showPrompt');
    }
    else {
        $('.firstPrompt').addClass('showPrompt');
    }

    setTimeout(() => {
        currentPrompt.removeClass('moveUp');
    }, "400");  
}



if ($(window).width() >= 990) {
var timesPerSecond = 1; 
var wait = false;
$(document).on('mousemove', function (event) {
    if (!wait) {
        rotatePrompts();
        wait = true;
        setTimeout(function () {
            wait = false;
        }, 300 / timesPerSecond);
    } 
});
}*/


/*
var textRotateTiming;

function textRotate() {
if ($(window).width() < 990) {
     textRotateTiming = setInterval(rotatePrompts, 2500);
 }
 else {
    clearInterval(textRotateTiming);
 }
}

setTimeout(() => {
    textRotate();
}, "1500");  



setTimeout(() => {
    videoOverlay.addClass('showContent');
    initialOverlay.removeClass('showContent');
  }, "1500");

  function setLogoHeight() {
    logoHeight = $('.initial-landing img').height();
    document.querySelector(':root').style.setProperty('--prelaunch-logo-height', `${logoHeight}px`);
  }

  window.addEventListener("load", (event) => {
    setLogoHeight();
 });

  window.addEventListener('resize', function(event) {
    setLogoHeight();
    textRotate();
});

$('.enter-site').click(function() {
$('html').addClass('siteEntered');
$('.intro-overlay').addClass('removeBg');
$('.about-popup').addClass('showAboutPopup');
});
*/

$('.about-popup').click(function() {
    $(this).addClass('removePopup');
    $('html').addClass('enable-scroll');
    $('html').addClass('siteLoaded');
    localStorage.setItem("siteLoaded", "true");
});
}


